import { Done, Error, PointOfSale, Sync } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { IDevice_Row_With_Branch } from "../../services/device/device-service";
import { Attendance_Service } from "../../services/attendance/attendance-service";
import { INITIAL_FEEDBACK } from "../../utils/constants";
import { useState } from "react";

type Props = { device: IDevice_Row_With_Branch; org_code: string };

export default function Sync_Device_Attendance({ device, org_code }: Props) {
    const [feedback, set_feedback] = useState(INITIAL_FEEDBACK);

    async function sync_device_attendance() {
        set_feedback((f) => ({ ...f, loading: true }));

        const [data, error] = await Attendance_Service.sync_device_attendance(
            device.serial,
            org_code
            // org_api_key_map[org_code]
        );

        if (error) {
            set_feedback({
                loading: false,
                show: true,
                message: { title: error.message },
                severity: "error",
            });
            return;
        }

        if (data) {
            set_feedback({
                loading: false,
                show: true,
                message: { title: data.message },
                severity: "success",
            });
        }
    }

    return (
        <IconButton
            size="small"
            onClick={sync_device_attendance}
            color={feedback.severity}
        >
            <Tooltip
                title={
                    feedback.loading
                        ? "Syncing device attendance..."
                        : feedback.message.title || "Sync Device Attendance"
                }
            >
                {feedback.loading ? (
                    <CircularProgress size={20} />
                ) : feedback.severity === "error" ? (
                    <Error />
                ) : feedback.severity === "success" ? (
                    <Done />
                ) : (
                    <PointOfSale fontSize="small" />
                )}
            </Tooltip>
        </IconButton>
    );
}
